import appConfig from '@/app.config.js'

export default class FullScreen {

    constructor() {

        this.isFullScreen = false
        this.elem = document.documentElement
    }

    toggle(background) {

        this.elem.classList.remove('fullscreen')

        if (!this.isFullScreen) {

            this.elem.classList.add('fullscreen')
            this.isFullScreen = true
            return this.open(background)
        }

        this.isFullScreen = false
        return this.close()
    }

    open(background) {

        if (this.elem.requestFullscreen) {
            this.elem.requestFullscreen();
        } else if (this.elem.mozRequestFullScreen) { /* Firefox */
            this.elem.mozRequestFullScreen();
        } else if (this.elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
            this.elem.webkitRequestFullscreen();
        } else if (this.elem.msRequestFullscreen) { /* IE/Edge */
            this.elem.msRequestFullscreen();
        }

        this.setBackground(background)
    }

    close() {

        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.mozCancelFullScreen) { /* Firefox */
            document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
            document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) { /* IE/Edge */
            document.msExitFullscreen();
        }

        this.resetBackground()
    }

    setBackground(background) {


        this.elem.style.backgroundImage = 'linear-gradient(180deg, ' + background.color + ', ' + appConfig.colors[background.color] + ')'

        if (background.type == 'image') {

            this.elem.style.backgroundImage = 'url(' + background.image + ')'
        }

        this.elem.style.backgroundSize = 'cover'
        this.elem.style.backgroundPosition = 'center'
    }

    resetBackground() {

        this.elem.style.backgroundImage = 'none'
    }

    checkFullScreen () {

        this.isFullScreen = this.elem.classList.toString().includes('fullscreen')

        return this.isFullScreen
    }
}
